import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=8aedf70a&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8aedf70a')) {
      api.createRecord('8aedf70a', component.options)
    } else {
      api.reload('8aedf70a', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=8aedf70a&", function () {
      api.rerender('8aedf70a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pObP9khw6lOP/JS/comp/seasonprices.vue"
export default component.exports